import axios from 'axios';

const endpoint: string = `${process.env.REACT_APP_API_V1}/CmsContent`;

const cmsAPI = {
  fetch: (slug: string, lang: string) => axios.get(`${endpoint}/${slug}?lang=${lang}`),
};

export default cmsAPI;
